import type { ButtonProps } from "@rivet-gg/components";

export function CreateActorButton(props: ButtonProps) {
	return null;
}
